/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const { pathname } = useLocation();

  return (
    <>
      <div className="collapse navbar-collapse custom-navmenu" id="main-navbar">
        <div className="container py-2 py-md-5 p-20-res">
          <div className="row align-items-start">
            <div className="col-md-2">
              <ul className="custom-menu">
                <li className={pathname === "/" ? "active" : ""}>
                  <Link to="/">Home</Link>
                </li>
                <li className={pathname === "/profile" ? "active" : ""}>
                  <Link to="/profile">About me</Link>
                </li>
                <li className={pathname === "/contact" ? "active" : ""}>
                  <Link to="/contact">Contact Me</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-light custom-navbar">
        <div className="container mrl-16-res">
          <a className="navbar-brand" href="/">
            WS.
          </a>
          <a href="#" className="burger" data-bs-toggle="collapse" data-bs-target="#main-navbar">
            <span></span>
          </a>
        </div>
      </nav>
    </>
  );
}
